const referenceMask = /\^|(store\.[^.]+)|([^.]+)/g;
export class CompiledReference {
    constructor(reference, splitTail = false) {
        const path = reference
            .match(referenceMask)
            .map(key => {
            if (key === '^' || key === 'owner')
                return 'getOwner()';
            if (key[0] === '~')
                return `getStore().get("${key.substr(1)}")`;
            if (key.indexOf('store.') === 0)
                return `getStore().get("${key.substr(6)}")`;
            return key;
        });
        this.tail = splitTail && path.pop();
        this.local = !path.length;
        this.resolve = new Function('self', `
            var v = self.${path.shift()};
                           
            ${path.map(x => `
                v = v && v.${x};
            `).join('')}

            return v;
        `);
    }
}
export function resolveReference(root, reference, action) {
    const path = reference.match(referenceMask), skip = path.length - 1;
    let self = root;
    for (var i = 0; i < skip; i++) {
        const key = path[i];
        switch (key) {
            case '~':
                self = self.getStore();
                break;
            case '^':
                self = self.getOwner();
                break;
            default: self = self.get(key);
        }
        if (!self)
            return;
    }
    return action(self, path[skip]);
}
//# sourceMappingURL=traversable.js.map